import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import { Editor } from 'react-draft-wysiwyg';
import {
    EditorState, ContentState,
    convertToRaw
} from 'draft-js';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button
} from 'reactstrap';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-table/react-table.css';
import './Quick-Answer.scss';
import { withRouter } from 'react-router-dom';
import InputTag from '../../Components/Input-Tag/Input-Tag'


const AnswerDetails = (props, { history }) => {

    const [loading, setLoading] = useState(true)
    const [modalExcluir, setModalExcluir] = useState(false)
    const [idFrase, setIdFrase] = useState()

    const [loadingAdicionar, setLoadingAdicionar] = useState(false)
    const [loadingExcluir, setLoadingExcluir] = useState(false)
    const [tags, setTags] = useState([])

    const [editorStateTexto, setEditorStateTexto] = useState('')
    const [formState, setFormState] = useState({
        titulo: '',
    })

    const toolbar = {
        inline: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            dropdownClassName: undefined,
            options: ['bold', 'italic', 'underline', 'subscript', 'superscript'],
        },
        blockType: {
            inDropdown: true,
            options: [],
            className: 'd-none'
        },
        fontSize: {
            options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
            className: 'd-none',
            component: undefined,
            dropdownClassName: undefined,
        },
        fontFamily: {
            options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana'],
            className: 'd-none',
            component: undefined,
            dropdownClassName: undefined,
        },
        list: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            dropdownClassName: undefined,
            options: [],
        },
        textAlign: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            dropdownClassName: undefined,
            options: ['center'],
        },
        colorPicker: {
            className: 'd-none',
            component: undefined,
            popupClassName: undefined,
            colors: [],
        },
        link: {
            inDropdown: false,
            className: 'd-none',
            component: undefined,
            popupClassName: undefined,
            dropdownClassName: undefined,
            showOpenOptionOnHover: true,
            defaultTargetOption: '_self',
            options: ['link', 'unlink'],
            linkCallback: undefined
        },
        emoji: {
            className: 'd-none',
            component: undefined,
            popupClassName: undefined,
            emojis: [
                '😀', '😁', '😂', '😃', '😉', '😋', '😎', '😍', '😗', '🤗', '🤔', '😣', '😫', '😴', '😌', '🤓',
                '😛', '😜', '😠', '😇', '😷', '😈', '👻', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '🙈',
                '🙉', '🙊', '👼', '👮', '🕵', '💂', '👳', '🎅', '👸', '👰', '👲', '🙍', '🙇', '🚶', '🏃', '💃',
                '⛷', '🏂', '🏌', '🏄', '🚣', '🏊', '⛹', '🏋', '🚴', '👫', '💪', '👈', '👉', '👉', '👆', '🖕',
                '👇', '🖖', '🤘', '🖐', '👌', '👍', '👎', '✊', '👊', '👏', '🙌', '🙏', '🐵', '🐶', '🐇', '🐥',
                '🐸', '🐌', '🐛', '🐜', '🐝', '🍉', '🍄', '🍔', '🍤', '🍨', '🍪', '🎂', '🍰', '🍾', '🍷', '🍸',
                '🍺', '🌍', '🚑', '⏰', '🌙', '🌝', '🌞', '⭐', '🌟', '🌠', '🌨', '🌩', '⛄', '🔥', '🎄', '🎈',
                '🎉', '🎊', '🎁', '🎗', '🏀', '🏈', '🎲', '🔇', '🔈', '📣', '🔔', '🎵', '🎷', '💰', '🖊', '📅',
                '✅', '❎', '💯',
            ],
        },
        embedded: {
            className: 'd-none',
            component: undefined,
            popupClassName: undefined,
            embedCallback: undefined,
            defaultSize: {
                height: 'auto',
                width: 'auto',
            },
        },
        image: {
            className: "d-none",
            component: undefined,
            popupClassName: undefined,
            urlEnabled: true,
            uploadEnabled: true,
            alignmentEnabled: true,
            uploadCallback: undefined,
            previewImage: false,
            inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
            alt: { present: false, mandatory: false },
            defaultSize: {
                height: 'auto',
                width: 'auto',
            },
        },
        remove: { className: undefined, component: undefined },
        history: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            dropdownClassName: undefined,
            options: ['undo', 'redo'],
        },
    };

    const chamaFrase = () => {
        const id = props.match.params.idResposta
        const config = new Configurations();
        axios.get(config.apiBasePath + `/resposta-rapida/${id}`)
            .then(response => {
                editContent(response.data.data[0].descricao)
                setTags(response.data.data[0].termos)
                setFormState({
                    titulo: response.data.data[0].titulo,
                })
                setIdFrase(id)

            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setLoading(false)

            });
    }

    const editContent = (_texto) => {
        let _editorStateTexto

        if (_texto) {
            const contentBlockTexto = htmlToDraft(_texto);
            if (contentBlockTexto) {
                const contentStateTexto = ContentState.createFromBlockArray(contentBlockTexto.contentBlocks);
                _editorStateTexto = EditorState.createWithContent(contentStateTexto);
                setEditorStateTexto(_editorStateTexto)
            }
        } else {
            _editorStateTexto = EditorState.createEmpty();
        }
    }

    const onEditorStateChange = (newState) => {
        setEditorStateTexto(newState);
    };

    const styleMap = {
        'SUBSCRIPT': {
            fontSize: 8
        },
    };

    const atualizaTags = (_tags) => {
        setTags(_tags)
    }



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const EditarFrase = () => {
        const config = new Configurations();
        const _body = {
            "titulo": formState.titulo,
            "descricao": draftToHtml(convertToRaw(editorStateTexto.getCurrentContent())),
            "termo": tags ? tags.map(tag => tag) : []
        };

        axios.put(config.apiBasePath + `/resposta-rapida/${idFrase}`, _body)
            .then(() => {
                setLoadingAdicionar(true)

            }).catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                window.history.go(-1)
            )
    }

    const excluirResposta = () => {
        setLoadingExcluir(true);
        const config = new Configurations();
        axios.delete(config.apiBasePath + `/resposta-rapida/${idFrase}`)
            .then(() => {
                setLoadingExcluir(false)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                window.history.go(-1)
            )
    }

    const toggleModalExcluir = () => {
        setModalExcluir(!modalExcluir)
    }

    useEffect(() => {
        chamaFrase()
    }, [])


    return (
        <>
            <div className="row detalhes-frase">
                <div className="header-resposta border-left border-bottom border-gray">
                    <div className="row no-gutters py-3 align-items-center">
                        <div className="col-4 pl-2 text-center text-lg-left">
                            <h2 className="d-none d-lg-block">Resposta rápida</h2>
                        </div>

                        <div className="col-2 text-center">
                            <button className="btn btn-outline-success" onClick={() => EditarFrase()} >Salvar</button>
                        </div>
                        <div className="col-2 text-center">
                            <button className="btn btn-outline-danger" onClick={() => setModalExcluir(true)}>Excluir</button>
                        </div>
                        <div className="col-2 text-center">
                            <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">Voltar</button>
                        </div>
                    </div>
                </div>
            </div>

            {loading ?
                <div className="spinner-border text-primary" role="status" />
                :
                <div className='row' style={{ marginTop: '80px' }}>
                    <div className='col-12 pb-2'>
                        <label className="m-0">Título:</label>
                        <input name="titulo" type="text" className="form-control" autoComplete="off" value={formState.titulo} onChange={handleInputChange} />
                    </div>

                    <div className='col-12 py-3'>
                        <label className="m-0">Descrição:</label>

                        <Editor
                            editorState={editorStateTexto}
                            wrapperClassName="demo-wrapper"
                            onEditorStateChange={(editorState) => onEditorStateChange(editorState, "editorStateTexto")}
                            toolbar={toolbar}
                            toolbarClassName="custom-toolbar"
                            editorClassName="custom-editor-texto border px-3"
                            handlePastedText={() => false}
                            customStyleMap={styleMap}
                        />
                    </div>

                    <div className='col-12 pb-2 tags-term'>
                        <label className="m-0">Termos:</label>
                        <InputTag atualizaTags={atualizaTags} tags={tags} textInput={true} />
                    </div>

                    <div className='col-12 text-right'>
                        {loadingAdicionar ?
                            <div className="spinner-border text-primary" role="status" />
                            :
                            <button className='btn btn-outline-success' onClick={() => EditarFrase()} >Salvar</button>
                        }

                    </div>


                </div>}

            <Modal isOpen={modalExcluir} toggle={toggleModalExcluir}>
                <ModalHeader toggle={toggleModalExcluir}>Excluir Frase</ModalHeader>
                <ModalBody>
                    <p className="m-0">Tem certeza que deseja excluir a resposta?</p>
                    <p className="m-0">Essa operação não poderá ser desfeita.</p>
                </ModalBody>
                <ModalFooter>
                    {loadingExcluir ? <div className="spinner-border text-danger" role="status" /> : <Button color='danger' onClick={() => excluirResposta()}>excluir</Button>}
                    {' '}<Button color="secondary" onClick={toggleModalExcluir}>voltar</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default withRouter(AnswerDetails);
